import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SearchTvErrorCodeComponent } from './search-tv-error-code/search-tv-error-code.component';
import { StartShellComponent } from './start/start-shell/start-shell.component';
import { DeflectionShellComponent } from './deflection/deflection-shell.component';
import { WhichTVBoxShellComponent } from '../shared/components/which-tv-box/containers/which-tv-box-shell/which-tv-box-shell.component';
import { UniversalIdGuard } from '@/shared/feature/universal-identification/guard/universal-id.guard';

const routes: Routes = [
  {
    path: '',
    component: SearchTvErrorCodeComponent,
  },
  {
    path: ':actionCode',
    children: [
      {
        path: 'start',
        data: { reloadComponent: true },
        component: StartShellComponent,
      },
    ],
  },
  {
    path: ':workflowName',
    children: [
      {
        path: ':actionCode',
        children: [
          {
            path: '~deflection',
            component: DeflectionShellComponent,
            canActivate: [UniversalIdGuard]
          },
          {
            path: 'which-tv-box',
            component: WhichTVBoxShellComponent,
            canActivate: [UniversalIdGuard],
            data: { strapiUID: 'dc_tv-error-codes_which-tv-box' },
          },
        ],
      },
    ],
  },
  {
    path: '',
    loadChildren: () =>
      import('@/shared/feature/diagnostics-flow/diagnostics-flow.module').then((m) => m.DiagnosticsFlowModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TVErrorCodesRoutingModule {}
